const prod = {
    firebase: {
        apiKey: "AIzaSyA9o8MCQK5qORgjzzW1W-4Sbn8szrxClrI",
        authDomain: "appli-app-daa85.firebaseapp.com",
        projectId: "appli-app-daa85",
        storageBucket: "appli-app-daa85.firebasestorage.app",
        messagingSenderId: "212636749036",
        appId: "1:212636749036:web:ec8f8652f904fef45a69c9",
    },
    hrApiUrl: "https://hr-api.applisolutions.com",
    coreApiUrl: "https://core-api.applisolutions.com",
    marketplaceUrl: "https://network.applisolutions.com",
    marketplaceApiUrl: "https://marketplace-api.applisolutions.com",
};

export default prod;
